import { render, staticRenderFns } from "./CitiesView.vue?vue&type=template&id=23d0f6a0&scoped=true&"
import script from "./CitiesView.vue?vue&type=script&lang=js&"
export * from "./CitiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0f6a0",
  null
  
)

export default component.exports